<template>
  <div class="vip-page" v-if="loaded">
    <div class="nologin" v-if="!pageData.id">
      <van-button
        style="width: 100px"
        type="danger"
        v-rblink="{name:'login','query':{ }}"
        plain
        round
        size="large"
      >登录/注册</van-button>
    </div>
    <div :class="{mohu:!(pageData.id>0)}">
      <div class="vip-header">
        <div class="vip-header-top">
          <img v-if="pageData.face" class="face" :src="pageData.face" />
          <span>{{pageData.name}}</span>
          <van-rate
            style=" padding:3px 0 0 6px; float: left"
            :value="pageData.group_star"
            :size="12"
            :count="pageData.group_star"
            color="#FAAD14"
            disabled-color="#FD2840"
          />
          <div class="cf"></div>
        </div>
        <div class="cf"></div>
        <div class="vip-card">
          <div class="icon-question" v-rblink="{name:'cmsDetail','query':{id :5 }}"></div>
          <p class="title1">可用积分</p>
          <p class="score">{{pageData.score1}}</p>
          <p class="note">可直接使用积分抵现</p>
          <div class="vip-progress">
            <div class="done" :style="{width: pageData.up_percent}"></div>
          </div>
          <div class="level">
            <span class="fl">{{pageData.current_group.name}}({{pageData.current_group.score}})</span>
            <span class="fr">{{pageData.next_group.name}}({{pageData.next_group.score}})</span>
            <div class="cf"></div>
          </div>
        </div>
      </div>

      <div class="vip-rights">
        <div class="vip-rights-header">尊享特权</div>
        <div class="flex-wrap">
          <div class="item flex-item-1">{{pageData.rights[0]}}</div>
          <div class="item flex-item-1">{{pageData.rights[1]}}</div>
          <div class="item flex-item-1">{{pageData.rights[2]}}</div>
          <div class="item flex-item-1">{{pageData.rights[3]}}</div>
        </div>
      </div>
      <div class="score-btn">
        <van-button
          style="width: 100px"
          type="danger"
          @click="updateScore"
          plain
          round
          size="large"
        >同步积分</van-button>
      </div>
      <!-- <div class="vip-task" v-if="pageData.task_list.length>0">
                <div class="vip-task-header">会员任务</div>
                <div>
                    <div class="li" v-for="task in pageData.task_list">
                        <div class="con">
                            <p>{{task.title}}<em>+{{task.score}} 积分</em></p>
                            <p class="desc">{{task.desc}}</p>
                        </div>
                        <div class="btn" v-rblink="task.link">
                            去领取
                        </div>
                        <div class="cf"></div>
                    </div>
                </div>
      </div>-->
    </div>

    <!-- 底部导航 -->
    <!-- <NaviBar :show-navi-bar = 'showNaviBar'></NaviBar> -->
  </div>
</template>

<style scoped="">
.score-btn {
  padding: 20px 0 30px 0;
  display: flex;
  justify-content: center;
}
</style>
<script>
// import NaviBar from '../Common/naviBar';
// import CountDot from '../Common/countDot';
import Vue from "vue";
import { Cell, CellGroup, Rate, Button, Dialog, Toast } from "vant";
Vue.use(Toast);
export default {
  name: "vip",
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Rate.name]: Rate,
    [Button.name]: Button
  },
  data: function() {
    return {
      showNaviBar: true,
      loaded: false,
      pageData: {
        id: 0,
        name: "--",
        face: "",
        rights: ["", "", "", ""],
        current_group: {
          name: "",
          score: ""
        },
        next_group: {
          name: "",
          score: ""
        },
        task_list: []
      },
      user_row: {},
      lisr: []
    };
  },
  mounted: function() {
    document.title = "会员中心";
    var that = this;
    that.fetch();
  },
  methods: {
    fetch() {
      let that = this;
      this.$api.get("/api/user/vippage", null, function(r) {
        that.pageData = r.data;
        that.loaded = true;
      });
    },
    updateScore() {
      let that = this;
      Toast.loading({
        message: "正在查询...",
        forbidClick: true,
        duration: 0
      });
      this.$api.get(
        "/api/user/getUpdateScore",
        { phone: that.pageData.phone },
        res => {
          console.log(res);
          that.user_row = res.data.user;
          that.list = res.data.list;
          Toast.success("查询成功");
          Dialog.confirm({
            title: "警告",
            message: "是否更新最新积分"
          })
            .then(() => {
              this.onSave();
            })
            .catch(() => {
              // this.onCancel()
            });
        },
        err => {
          Toast.fail(err.msg);
        }
      );
    },
    onSave() {
      let that = this;
      Toast.loading({
        message: "正在更新...",
        forbidClick: true,
        duration: 0
      });
      this.$api.post(
        "/api/user/updateScoreSave",
        {
          user_id: that.pageData.id,
          phone: that.pageData.phone,
          list: that.list
        },
        res => {
          Toast.success("更新成功");
          that.fetch();
        },
        err => {
          Toast.fail("更新失败");
        }
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// vip.vue?b1c46894